<template>
  <i :class="computedClass"></i>
</template>
<script>
export default {
  name: "ActiveIcon",
  props: {
    val: {
      type: Boolean
    }
  },
  computed: {
    computedClass() {
      return {
        icon: true,
        "el-icon-success": this.val,
        "el-icon-error": !this.val,
        green: this.val,
        red: !this.val
      };
    }
  }
};
</script>
<style scoped>
.icon {
  font-size: 1.5em;
}
.green {
  color: #67c23a;
}
.red {
  color: #f56c6c;
}
</style>



// WEBPACK FOOTER //
// src/components/ui/ActiveIcon.vue